import type { CityConfig } from "../city-template/types";

export const ellicottCityConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Maryland Vital Records (Birth, Death, Marriage)", href: "https://health.maryland.gov/vsa/Pages/Home.aspx", description: "Official Maryland Department of Health vital records office in Baltimore" },
    { label: "Howard County — Marriage &amp; Vital Records", href: "https://www.howardcountymd.gov/", description: "Howard County — local marriage licenses and vital records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maryland DOH for online vital record orders" },
  ],
  city: "Ellicott City",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "ellicott-city",
  route: "/ellicott-city",
  title: "Emergency Passport Ellicott City, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Ellicott City, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Ellicott City, Columbia, Catonsville, and Sykesville residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Ellicott City, MD",
  heroSubtitle: "Ellicott City travelers — from historic Main Street residents to Howard County families to Patapsco Valley visitors — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Howard County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic Ellicott City Maryland downtown along Main Street with charming 19th-century stone buildings, cascading Patapsco River visible, unique boutique shops, warm afternoon golden hour lighting, professional Howard County photography, no visible text or people, clean architectural details, autumn foliage and small-town atmosphere\u0026width=1800\u0026height=700\u0026seq=ellicott-city-hero-001\u0026orientation=landscape",
  heroImageAlt: "Historic Ellicott City Maryland downtown along Main Street with charming stone buildings and Patapsco River",
  geoPosition: "39.2673;-76.7983",
  geoPlacename: "Ellicott City, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 45–55 minutes from Ellicott City via I-95 S",
  },
  nearbyCitiesZips: [
    { name: "Ellicott City", zips: "21041, 21042, 21043, 21045" },
    { name: "Columbia", zips: "21044, 21045, 21046" },
    { name: "Catonsville", zips: "21228, 21229, 21250" },
    { name: "Sykesville", zips: "21784" },
    { name: "Woodstock", zips: "21163" },
    { name: "Marriottsville", zips: "21104" },
    { name: "West Friendship", zips: "21794" },
    { name: "Glenelg", zips: "21737" },
    { name: "Dayton", zips: "21036" },
    { name: "Jessup", zips: "20794" },
    { name: "Laurel", zips: "20707, 20708, 20709, 20723, 20724, 20725" },
    { name: "Fulton", zips: "20759" },
    { name: "Highland", zips: "20777" },
    { name: "Baltimore", zips: "21201, 21202, 21205, 21206, 21209, 21210, 21211, 21212, 21213, 21214, 21215, 21216, 21217, 21218, 21222, 21223, 21224, 21225, 21226, 21227, 21228, 21229, 21230, 21231, 21234, 21236, 21237, 21239, 21251" },
    { name: "Towson", zips: "21204, 21252, 21284, 21285, 21286" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Ellicott City and Howard County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-community-line", title: "Historic Howard County", desc: "Serving Ellicott City historic district and Columbia planned community" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Columbia, MD", route: "/columbia" },
    { name: "Emergency passport help in Catonsville, MD", route: "/catonsville" },
    { name: "Urgent passport services in Baltimore, MD", route: "/baltimore" },
    { name: "Maryland passport services overview", route: "/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Ellicott City, Maryland remotely via secure registered courier. We do not have a walk-in office in Ellicott City — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Ellicott City and Howard County travelers without the drive to downtown DC.",
  fpcOfficeAddress: "401 E Pratt St, Baltimore, Maryland 21202",
  fpcOfficeDistance: "Serving Ellicott City, Columbia, Catonsville, Sykesville, and greater Howard County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Ellicott City and Howard County. From the historic Ellicott City downtown along Main Street to the modern planned community of Columbia, from the Patapsco Valley to the suburban neighborhoods of Sykesville and Woodstock — we serve all of Howard County's diverse communities.",
  nearbyCitiesIntro: "We serve Ellicott City and nearby communities including Columbia, Catonsville, Sykesville, Woodstock, Marriottsville, West Friendship, Glenelg, Dayton, Jessup, Laurel, Fulton, and Highland. We also serve Baltimore, Towson, and greater Howard County residents who prefer our expedited service.",
  howItWorksIntro: "Most Ellicott City travelers complete everything online and ship documents overnight. No need to drive 45–55 minutes to downtown DC or navigate Baltimore Beltway traffic.",
  mistakesIntro: "Ellicott City is one of Howard County's most historic and affluent communities with a mix of old-town residents and modern suburban families. Here are the most common passport mistakes we see from Ellicott City travelers.",
  testimonialsIntro: "Ellicott City travelers — from historic Main Street homeowners to Columbia families to Patapsco Valley residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Ellicott City, MD? Here are the most common ones we hear from Howard County travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for family and historic district travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 45–55 min to downtown DC", "Full day commitment — challenging for working families"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Ellicott City travelers with immediate departure needs — as fast as 24 hours. Critical for families and professionals who need fast turnaround.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Family and professional travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Ellicott City adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Ellicott City address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Ellicott City residents and families — including Columbia community members.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Ellicott City residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Ellicott City families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Ellicott City residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Ellicott City MD", description: "Urgent passport processing for Ellicott City Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Ellicott City MD", description: "Fast passport renewal for Ellicott City Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Ellicott City MD", description: "New passport application services for Ellicott City Maryland residents applying for their first passport." },
    { name: "Child Passport Ellicott City MD", description: "Minor passport services for Ellicott City Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Susan P.",
      location: "Ellicott City, MD",
      rating: 5,
      text: "Family trip to London with 8 days notice. Fast Passport Center processed four passports in under a week. The agent was incredibly helpful and reviewed everything twice.",
      service: "Family Passport Bundle",
    },
    {
      name: "Michael T.",
      location: "Columbia, MD",
      rating: 5,
      text: "Business trip to Tokyo with 6 days notice. They caught a form issue before submission and had my passport in 48 hours. Saved my company's international deal.",
      service: "Emergency Passport",
    },
    {
      name: "Rachel B.",
      location: "Sykesville, MD",
      rating: 5,
      text: "Study abroad in Spain with 10 days notice. Everything was handled online. My passport arrived at my Sykesville home in 3 days.",
      service: "Emergency Passport",
    },
    {
      name: "Kevin D.",
      location: "Ellicott City, MD",
      rating: 5,
      text: "Lost my passport before a cruise. They had a replacement in my hands in 36 hours. I didn't have to drive to DC — just shipped overnight from our local FedEx.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "ellicott-1",
      name: "Ellicott City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3375 Court House Dr",
      city: "Ellicott City",
      state: "MD",
      zip: "21043",
      phone: "(410) 465-2800",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ellicott City, near the courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Ellicott City acceptance facility. Appointments required — book 1–2 weeks in advance. Accessible from US-40.",
      icon: "ri-mail-line",
    },
    {
      id: "ellicott-2",
      name: "Columbia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8805 Centre Park Dr",
      city: "Columbia",
      state: "MD",
      zip: "21045",
      phone: "(410) 997-8802",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Columbia, approximately 6 miles southeast of Ellicott City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Columbia and eastern Howard County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "ellicott-3",
      name: "Catonsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1501 Frederick Rd",
      city: "Catonsville",
      state: "MD",
      zip: "21228",
      phone: "(410) 744-5158",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Catonsville, approximately 7 miles east of Ellicott City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for eastern Howard County and western Baltimore County residents. Good alternative when Ellicott City appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "ellicott-4",
      name: "Howard County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "8360 Court Ave",
      city: "Ellicott City",
      state: "MD",
      zip: "21043",
      phone: "(410) 313-2200",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Ellicott City, near the historic district",
      website: "https://www.howardcountymd.gov/",
      websiteLabel: "Howard County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office locations. Best option for first-time applications.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 45–55 min drive to downtown DC", fpc: "No — ship from Ellicott City" },
    { feature: "Howard County Support", agency: "No flexibility for local needs", fpc: "Yes — we understand Howard County families" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Ellicott City's busy families and professionals often discover passport needs just weeks before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Ellicott City sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Ellicott City and Howard County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Ellicott City Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Ellicott City residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Ellicott City, Columbia, or Sykesville." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Ellicott City or along US-40." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Howard County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Ellicott City, MD?", a: "Fast Passport Center offers emergency passport processing in Ellicott City, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency (45–55 minutes from Ellicott City) — without you needing to make the drive or fight Baltimore Beltway traffic." },
    { q: "Does Ellicott City have its own passport agency?", a: "No — neither Ellicott City nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 45–55 minutes from Ellicott City via I-95 S. Fast Passport Center's courier service means Ellicott City residents never need to make that drive." },
    { q: "Can I get expedited passport services if I live in Columbia or Sykesville?", a: "Absolutely. Fast Passport Center serves all of the Ellicott City area including Columbia, Catonsville, Sykesville, Woodstock, Marriottsville, West Friendship, Glenelg, and Dayton. Our service works the same way — complete your application online, ship your documents, and we handle the rest." },
    { q: "How much does an expedited passport cost in Ellicott City, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Ellicott City travelers use for international flights?", a: "Most Ellicott City residents fly internationally through Baltimore-Washington International (BWI), approximately 20–25 minutes east via I-695. Dulles International (IAD) is 50–60 minutes southwest via I-695 and I-270. Reagan National (DCA) is 45–55 minutes south via I-95. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Ellicott City?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Ellicott City, Columbia, Sykesville, and surrounding areas. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Ellicott City?", a: "The Ellicott City Post Office at 3375 Court House Dr is the primary downtown acceptance facility. The Columbia Post Office at 8805 Centre Park Dr serves Columbia and eastern Howard County. The Catonsville Post Office at 1501 Frederick Rd serves western Baltimore County. The Howard County Clerk's Office at 8360 Court Ave also provides passport acceptance. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Ellicott City residents should plan ahead, especially for family vacations and international travel." },
  ],
  photoLocations: [
    { name: "Walgreens — Ellicott City", address: "10000 Baltimore National Pike, Ellicott City, MD 21042", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com" },
    { name: "CVS Pharmacy — Ellicott City", address: "9240 Baltimore National Pike, Ellicott City, MD 21042", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com" },
    { name: "UPS Store — Columbia", address: "6490 Dobbin Center Way, Columbia, MD 21045", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com" },
    { name: "FedEx Office — Columbia", address: "8825 Centre Park Dr, Columbia, MD 21045", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com" },
  ],
  dmvLocations: [
    { name: "MVA — Columbia", address: "6490 Dobbin Center Way, Columbia, MD 21045", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Howard County and western Baltimore County. REAL ID processing available.", featured: true },
    { name: "MVA — Glen Burnie", address: "6601 Ritchie Hwy NE, Glen Burnie, MD 21062", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Serves Anne Arundel and Baltimore County. Full service including REAL ID.", featured: false },
  ],
  airports: [
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "20–25 minutes from Ellicott City via I-695 E",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Primary departure airport for Ellicott City travelers. Southwest Airlines hub with direct flights to major US cities and international connections.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: true,
    },
    {
      code: "DCA",
      name: "Reagan National (Washington DC)",
      distance: "45–55 minutes from Ellicott City via I-95 S",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Secondary option for domestic connections to international hubs.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International",
      distance: "50–60 minutes from Ellicott City via I-695 W and I-270 W",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for international flights and United Airlines hub connections.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};